import {
  AppSelect,
  TOption,
} from '../../../components/appSelect';
import cameraLogo from '../../../assets/icons/camera.svg';

type TProps = {
  selectedValue: string;
  onChange: (val: string) => void;
};

const OPTIONS: TOption[] = [
  {
    value: 'realistic',
    label: 'Realistic',
  },
  {
    value: 'cartoon',
    label: 'Cartoon',
  },
  {
    value: 'surprise',
    label: 'Surprise Me',
  },
];

export const ImageStyle = ({
  selectedValue,
  onChange,
}: TProps) => {
  return (
    <AppSelect
      label="Output style"
      selectIcon={cameraLogo}
      selectedValue={selectedValue}
      onChange={onChange}
      options={OPTIONS}
    />
  );
};
